export default __webpack_public_path__ + "static/media/516.d5cc047b.gif";